// extracted by mini-css-extract-plugin
export var arrow = "_3p-6";
export var changeItem = "_3p-3";
export var changesHeader = "_3p-1";
export var changesList = "_3p-2";
export var container = "_3p-0";
export var pathLabel = "_3p-4";
export var value = "_3p-7";
export var valuesContainer = "_3p-5";